import axios from 'axios';

// Create axios instance with interceptors for auto-logout on 401
const setupAxiosInterceptors = () => {
  // Response interceptor to handle 401 errors globally
  axios.interceptors.response.use(
    (response) => {
      // Return successful responses as-is
      return response;
    },
    (error) => {
      // Check if error is a 401 Unauthorized
      if (error.response && error.response.status === 401) {
        console.log('Session expired or invalid token - logging out');
        
        // Clear all auth data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
        localStorage.removeItem('role');
        
        // Show message (optional - some browsers may block this during redirect)
        try {
          // Dispatch custom event for any listeners
          window.dispatchEvent(new CustomEvent('auth:logout', { 
            detail: { reason: 'session_expired' } 
          }));
        } catch (e) {
          console.log('Could not dispatch logout event');
        }
        
        // Redirect to login page
        // Only redirect if not already on login page
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login?session=expired';
        }
      }
      
      // Return the error so individual catch blocks can still handle it
      return Promise.reject(error);
    }
  );

  // Request interceptor to add token to all requests
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
